import React, { useState, useEffect, useRef } from "react";
import { useMapsLibrary } from "@vis.gl/react-google-maps";
import { Input } from "../../ui/_forms/Input";

export interface PlacesAutocompleteInputBoxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onPlaceSelect: (place: google.maps.places.PlaceResult | null) => void;
}

export const PlacesAutocompleteInputBox: React.FC<PlacesAutocompleteInputBoxProps> = ({ onPlaceSelect }) => {
  const [autocomplete, setAutocomplete] = useState<google.maps.places.Autocomplete | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const placesLib = useMapsLibrary("places");

  useEffect(() => {
    if (!placesLib || !inputRef.current) return;
    const options: google.maps.places.AutocompleteOptions = {
      fields: ["geometry", "address_components", "formatted_address", "name"]
    };
    setAutocomplete(new placesLib.Autocomplete(inputRef.current, options));
  }, [placesLib]);

  useEffect(() => {
    if (!autocomplete) return;
    const listener = autocomplete.addListener("place_changed", () => {
      onPlaceSelect(autocomplete.getPlace());
    });
    return () => listener.remove();
  }, [autocomplete, onPlaceSelect]);

  return (
    <div className="mb-3">
      <Input
        ref={inputRef}
        id="googleSearch"
        className="form-control"
        placeholder="Search for places"
        borderStyle="underline"
      />
    </div>
  );
};
